// src/context/UserContext.js

import React, { createContext, useContext, useState } from "react";

// Default user for testing — you can change role to 'admin', 'clinician', or 'receptionist'
const initialUser = {
  name: "Admin User",
  role: "admin", // Change to 'clinician' or 'receptionist' to test permissions
};

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(initialUser);

  // Optionally, add a way to switch role for testing/demo purposes
  const switchRole = (role) => setUser((u) => ({ ...u, role }));

  return (
    <UserContext.Provider value={{ user, setUser, switchRole }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
